
/* eslint-disable import/no-anonymous-default-export */
export default {
    robb: '青萍室內環境檢測儀',
    robb_banner_desc:'8 項數據，精準監測',
    robb_product_desc1:'溫度 · 濕度 · PM2.5 · PM10{br}CO2 · eTVOC · 噪音 · 照度',
    robb_product_desc2:'牆壁安裝 · 多種供電方式',
    robb_step1_name: '青萍室內環境檢測儀',
    robb_step1_desc: '牆壁安裝{spot}8 項讀數{spot}多種供電方式{spot}可更換 PM 傳感器',
    robb_m_step1_desc_1: '牆壁安裝',
    robb_m_step1_desc_2: '8 項讀數',
    robb_m_step1_desc_3: '多種供電方式',
    robb_m_step1_desc_4: '可更換 PM 傳感器',
    robb_step2_name: '2 種主機',
    robb_step2_card_title: '墨水屏版',
    robb_step2_card_title2: '無螢幕版',
    robb_step2_card_i_text1: '超寬可視角度 ',
    robb_step2_card_i_text2: '超高對比度 ',
    robb_step2_card_i_text3: '彩色讀數{br}評價燈條{note}',
    robb_step2_card_i_text4: '按鈕切換讀數',
    robb_step2_card_i_text5:  '彩色讀數{br}評價燈條{note}',
    robb_step2_card_i_text6: '按鈕查看聯網狀態',

    robb_step3_name: '3 種供電模組',
    robb_step3_desc: '主機機身和供電模組通過連接器連接。',
    robb_step3_card_title1: '牆壁底盒交流電源模組',
    robb_step3_card_title2: '牆壁底盒低壓電源模組',
    robb_step3_card_title3: '壁裝低壓電源模組', 

    robb_pop_wall_box_h1: '牆壁底盒交流電源模組',
    robb_pop_wall_box_h2: '牆壁接線盒安裝，可直接替代已有 “86 盒”*型牆壁插座。',
    robb_pop_wall_box_tab_1_1: 'RS-485{br2}有線通信接口',
    robb_pop_wall_box_tab_2_1: '支持{br2}100–240V 交流電',
    robb_pop_wall_box_footer_text: '* “86 盒”是一種常見的接線盒規格，尺寸為 86 × 86 毫米。兼容中國、歐洲、英國的同尺寸接線盒。',

    robb_pop_wall_box_low_volt_h1: '牆壁底盒低壓電源模組',
    robb_pop_wall_box_low_volt_h2: '牆壁接線盒安裝，可直接替代已有 “86 盒”*型牆壁插座。',
    robb_pop_wall_box_low_volt_tab_1_1: 'RS-485 有線通信接口',
    robb_pop_wall_box_low_volt_tab_2_1: '支持 9-24V 交流電{br}或 9–30V 直流電',
    robb_pop_wall_box_low_volt_footer_text: '* “86 盒”是一種常見的接線盒規格，尺寸為 86 × 86 毫米。兼容中國、歐洲、英國的同尺寸接線盒。',

    robb_pop_wall_mounted_h1: '壁裝低壓電源模組',
    robb_pop_wall_mounted_h2: '包裝內有壁掛支架、雙面膠和螺絲釘，可用於固定。',
    robb_pop_wall_mounted_tab_1_1: '支持 9–24V 交流電{br}或 9–30V 直流電',
    robb_pop_wall_mounted_tab_2_1: 'USB-C 供電接口',
    robb_pop_wall_mounted_footer_text: '靈活的壁裝式設計，適用於多種安裝環境。',

    robb_step4_title: '3 種無線通信方案供您選擇{note}',
    robb_step4_wifi: '使用環境需有穩定的 Wi-Fi 信號。',
    robb_step4_lora: '需配備 LoRaWAN 網關或基站。',
    robb_step4_nbiot: '需當地中國移動提供相關網路服務{note}。',

    robb_step5_title: '8 項數據，精準監測',
    robb_step5_light: '照度',
    robb_step5_temp: '溫濕度',
    robb_step5_co2: 'CO2',
    robb_step5_pm25: 'PM2.5 {br}和 PM10',
    robb_step5_tvoc: 'eTVOC{sup}',
    robb_step5_noise: '噪音',
    robb_step5_memo1:
      '溫濕度不僅事關舒適性，也和健康息息相關。處於溫濕度不佳的環境，可能引發睡眠問題，甚至過敏反應或呼吸道疾病等。',
      robb_step5_memo2:
      '室內 二氧化碳 濃度過高，容易使人困倦，也意味著通風不良、空氣中其他污染物的積累。',
      robb_step5_memo3:
      '粒徑小、活性強，易附著有害物質，被人吸入後，可能對呼吸系統和心血管系統產生不良影響。',
      robb_step5_memo4:
      '包含上千種化合物，其中部分物質可能有刺激性氣味、部分物質可能對⼈體有害。',
      robb_step5_memo5:
      '噪音水平對人的睡眠質量和身體健康有影響。持續的噪音可能導致失眠、焦慮和壓力增加。長時間暴露在噪音過高的環境會引起聽力問題，甚至耳聾。',

    robb_step6_name:'可更換 PM 傳感器，便於維護',
    robb_step6_desc:'採用高品質光學器件，搭配磁懸浮風扇，準確性、可靠性俱佳。',


    robb_step7_title:'青萍+{note}',
    robb_step7_desc:'管理青萍家用智能設備，支持查看數據、{br}修改設置、升級固件等。',

    robb_step10_name:'多場景專業應用',
    robb_step10_desc:'可廣泛應用於家庭、學校、辦公樓、醫院、餐廳、商場、工廠、酒店、{br}實驗室等場景。',
    robb_step10_banner1_footer:'檢測辦公室、學校教室的空氣質量、照度、噪音水平等，適時採取改普措施，提供{br}健康舒適的工作、學習環境。',
    robb_step10_banner2_footer:'某些實驗、測試和生產過程對環境溫濕度有嚴格要求。監測並記錄實驗{br}室、工廠的溫濕度，以及時了解和應對重大變化。',
    
    robb_step11_name:'阻燃材料，安全可靠',
    robb_step11_desc:'殼體材料具有出色的阻燃性、絕緣性，不易變形、褪色。',

    robb_step12_1:'通過彩色讀數評價燈條指示室內環境水平，綠色為優、黃色為良、紅色為差。可通過青萍物聯 app 或網站修改讀數評價標準。',
    robb_step12_2:'支持定制其他無線通信方案，如 Thread、Zigbee、Cat-1、Cat-M 等。',
    robb_step12_3:'NB-IoT 版設備出廠內置 SIM 卡，含 6 年中國移動 NB-IoT 流量資費（限 50MB/年）。不同批次所包含的資費可能不同。',
    robb_step12_4:'本產品採用的 TVOC 傳感器會根據過去一段時間的讀數水平自動調整測量基線，故本產品顯示的是 eTVOC （即“TVOC 等效值”），並非準確的 TVOC 絕對讀數，僅供用戶觀察環境 TVOC 濃度的相對變化趨勢。',
    robb_step12_5:'僅 Wi-Fi 版本支持青萍+。',

    // specifications
    robb_size:'主機尺寸',
    robb_color:'顏色',
    robb_spec_size:'86 × 86 × 23 毫米',
    robb_color:'白色',
    robb_spec_long:'86 毫米',
    robb_spec_short:'23 毫米',
    robb_spec_height:'86 毫米',

    robb_temperature:'溫度',
    robb_humidity:'濕度',
    robb_co2_range:'二氧化碳',
    robb_pm_range:'PM2.5/PM10',
    robb_etvoc_range:'eTVOC',
    robb_noise_range:'噪音',
    robb_light_range:'照度',
    
    robb_temperature_range:'無屏版：-10 ~ 60°C{br}墨水屏版：0 ~ 50°C',
    robb_humidity_range:'0 ~ 99%RH（無凝露環境）{br}{hint}',
    robb_humidity_hint:'* 請勿長時間在濕度超過 90%RH 的環境下使用',
    robb_co2_value:'400 ~ 9999 ppm',
    robb_pm_value:'0 ~ 999 μg/m³',
    robb_etvoc_value:'VOC 指數 0 ~ 500，或 0.005 ~ 9.999 mg/m³',
    robb_noise_value:'36 ~ 95 dB',
    robb_light_value:'0 ~ 83000 lux',

    screen_resolution:'屏幕分辨率',
    robb_screen_resolution:'152 × 296 像素',
    robb_weight:'113 克',
    robb_screen_size:'36 × 72 毫米',
    robb_wifi:'Wi-Fi 2.4GHz 或 NB-IoT（CMCC）或 LoRa',
    robb_ble:'藍牙 5.0',

    robb_package_name:'室內環境檢測儀{br}主機',
    robb_package_battery:'PM 傳感器',
    robb_package_screen:'說明書',
    robb_package_screen_resolution:'螺絲刀{br}（僅用於安裝小螺絲）',
    robb_package_weight:'小螺絲 × 2',
    robb_temp:'溫度',
    robb_hum:'濕度',

    robb_step5_memo6: '過高或過低的光照強度可能導致眼部疲勞、學習和工作效率降低。過度使用照明設備，可能造成能源浪費。',

    robb_tab_1:'牆壁底盒交流電源模組',
    robb_tab_2:'牆壁底盒低壓電源模組',   
    robb_tab_3:'壁裝低壓電源模組',   
    robb_tab1_size:'82 × 82 × 33 毫米',
    robb_tab1_color:'白色',
    robb_tab1_left:'82 毫米',
    robb_tab1_left2:'33 毫米',
    robb_tab1_left3:'82 毫米',
    wired_connect:'有線通信',
    input:'輸入',
    robb_tab1_name:'青萍牆壁底盒交流電源模組',
    robb_tab1_weight:'62 克',
    robb_tab1_connect:'RS-485',
    robb_tab1_protect:'100–240V 交流電',
    robb_tab1_pack_7:'青萍牆壁底盒交流{br}電源模組',
    robb_tab1_pack_9:'大螺絲 × 4',
    robb_tab1_pack_10:'說明書',
    robb_tab2_name:'青萍牆壁底盒低壓電源模組',
    robb_tab2_pack_7:'青萍牆壁底盒低壓{br}電源模組',
    robb_tab2_protect:'9-24V 交流電或 9–30V 直流電',

    robb_tab3_size:'86 × 86 × 24 毫米',
    robb_tab3_color:'白色',
    robb_tab3_left:'86 毫米',
    robb_tab3_left2:'24 毫米',
    robb_tab3_left3:'86 毫米',
    robb_tab3_name: '青萍壁裝低壓電源模組',
    robb_tab3_weight: '57 g',
    robb_tab3_protect: '9–24V 交流電或 9–30V 直流電 或 USB-C 電源（5V⎓1A）',
    robb_tab3_pack_7:'青萍壁裝低壓電源模組',
    robb_tab3_pack_11:'壁裝支架',

    exterior_robb:'外觀',
    specifications_robb:'規格',
}